export const dummyCustomerOrders = [
  {
    order_id: '2701d432-04e5-492b-a054-7f32d6ac6c9e',
    order_no: '20241115-0057',
    grand_total: 287900,
    status: 'unpaid',
    created_at: '2024-11-15T10:23:12.200Z',
  },
];

export const dummyCustomerOrderDetail = {
  order_id: '2701d432-04e5-492b-a054-7f32d6ac6c9e',
  order_no: '20241115-0061',
  other_fee: 0,
  shipping_cost: 13000,
  insurance_cost: 0,
  cod_fee: 0,
  subtotal: 274900,
  total_disc: 0,
  total_tax: 0,
  tax: 0,
  grand_total: 287900,
  value: 287900,
  platform_fee: 1000,
  payment_method: 'online',
  awb_no: null,
  awb_track_link: null,
  source: 'store',
  notes: '-',
  tags: ['store_front'],
  created_at: '2024-11-15T10:38:25.090Z',
  updated_at: null,
  created_by: 'jhon doe',
  updated_by: null,
  location_id: '2701d432-04e5-492b-a054-7f32d6ac6c9e',
  payment_proof_url: null,
  payment_link: null,
  customer_id: '2701d432-04e5-492b-a054-7f32d6ac6c9e',
  status: 'unpaid',
  payment_channel: null,
  payment_type: null,
  disc_transaction: '0',
  disc_type: null,
  disc_fixed: '0',
  disc_percentage: '0',
  tax_include: false,
  reason: null,
  jstore_admin_fee: null,
  order_items: [
    {
      item_id: '2701d432-04e5-492b-a054-7f32d6ac6c9e',
      qty: 1,
      quantity: 1,
      disc: 0,
      tax: 0,
      price: 274900,
      item_snapshots: null,
      disc_amount: null,
      item_name: 'Black-28',
      sku: 'Exe-4Way_Stretch-Black-28',
      barcode: null,
      sell_price: 304950,
      item_weight: 600,
      item_height: 20,
      item_width: 10,
      item_length: 30,
      image:
        'https://dev-storage.jubelio.com/demo-b/images/jstorev2/cdc15b6c-3af1-4e27-aeee-992484e19841.jpeg',
      product_name: '4-Way Stretch Ankle Pants',
    },
  ],
  customer_address: {
    customer_id: '0193269e-9e16-74aa-a399-06dc8f8b4d62',
    first_name: 'jhon',
    last_name: 'doe',
    email: 'jhon.doe@gmail.com',
    phone: '08123456789',
    area: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
    area_id: '312345678',
    address: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry',
    zipcode: '12345',
  },
  shipping: {
    final_rates: 13000,
    discount_rates: 0,
    service_name: 'Paxel Nextday',
    eta_from: '2024-11-22T17:38:25+08:00',
    eta_to: '2024-11-29T17:38:25+08:00',
    shipping_province: null,
    shipping_province_id: null,
    shipping_city: null,
    shipping_city_id: null,
    shipping_district_id: null,
    shipping_area: null,
    shipping_subdistrict: null,
    shipping_subdistrict_id: null,
    shipping_post_code: null,
    shipping_address: null,
    shipping_phone: null,
    shipping_coordinate: null,
  },
};
